export default __webpack_public_path__ + "static/media/10-more-people.0a56a1d5.png";